import React from 'react'
import { Table } from 'react-bootstrap'
import EmptyComponent from '../../components/EmptyComponent'
import { COLOR_APP } from '../../constants'
import { imageRender } from '../../helpers'
import { convertOrderStatus } from '../../helpers/orderStatus'
import _ from 'lodash'

export default function OrderData({ goodProducts }) {

    if(_.isEmpty(goodProducts)) return <div>
        <img src='https://cdn.dribbble.com/users/1373705/screenshots/6457898/no_reservation_yiran.png?resize=400x300&vertical=center' />
    </div>

    return (
        <div>
             <Table responsive>
                <thead style={{ background: COLOR_APP, color: "#fff" }}>
                    {/* <tr>
                        <th>ລ/ດ</th>
                        <th>ຊື່ສິນຄ້າ</th>
                        <th>ຊື່ລູກຄ້າ</th>
                        <th>ສະຖານະ</th>
                    </tr> */}
                    <tr>
                        <th>ລ/ດ</th>
                        <th>ຊື່ສິນຄ້າ</th>
                        {/* <th>ຊື່ລູກຄ້າ</th> */}
                        <th>ຈໍານວນທີ່ສັ່ງຊື້</th>
                    </tr>
                </thead>
                <tbody style={{ background: "#eee" }}>
                    {goodProducts &&
                        goodProducts?.map((order, index) => (

                            <tr key={index} >
                                <td id="index">{index + 1}</td>
                                <td >{order?.name ?? "ຍັງບໍ່ກໍານົດ"}</td>
                                {/* <td >{order?.cfName ?? "ຍັງບໍ່ກໍານົດ"}</td> */}
                                <td >{order?.amount ?? "0"}</td>
                                {/* <td
                                    style={{
                                        color: (order?.status == "COMPLETED" || order?.status == "SHIPPING_COMPLETED") ? "green" : (
                                            order?.status == "USERCONFIRM" ? COLOR_APP : (
                                                order?.status == "CANCELLED" ? "red" : (
                                                    (order?.status == "CREATED" || !order?.status) ? "#000" : "orange"
                                                )
                                            )
                                        )
                                    }}
                                >
                                    {convertOrderStatus(order?.status)}
                                </td> */}
                            </tr>
                        ))}
                </tbody>
            </Table>  
        </div>
    )
}
